module.exports = __webpack_public_path__ + "static/sport/bg2.b8eed8f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ldp/bg2.png
// module id = 1q6J
// module chunks = 0